/* eslint-disable prefer-template */

import { config } from '../config/runtimeConfig';

const serverBaseUrl = config.REACT_APP_SERVER_HOSTNAME
  ? config.REACT_APP_SERVER_HOSTNAME +
    (config.REACT_APP_SERVER_PORT ? ':' + config.REACT_APP_SERVER_PORT : '')
  : window.location.hostname;

export const serverBaseWebSocketUrl =
  (config.REACT_APP_SERVER_WEBSOCKET_PROTOCOL || 'wss') + '://' + serverBaseUrl;
